module.exports = __webpack_public_path__ + "img/Banner-Gooday-Cloud-TM-logo.8491972d.png";